import { getAccessToken } from '@vangst/services/headers'
import useViewer from '@vangst/services/oogst/viewer/useViewer'
import Routes from '@vangst/services/routes'
import { useRouter } from 'next/router'
import React from 'react'

/**
 * Redirect an already authenticated viewer to their dashboard.
 * Used on pages like sign in|up, reset|forgot password, etc.
 */
function useAuthedRedirect() {
  const { authenticated } = useViewer()
  const { replace, query } = useRouter()
  React.useEffect(() => {
    if (authenticated) {
      // Handle redirects for moodle
      if (query?.redirect && query.redirect.includes('vangst.com')) {
        const token = getAccessToken()
        const tokenQuery = token ? `&token=${token}` : ''
        replace(`${query.redirect}${tokenQuery}`)
        return
      }
      replace((query?.redirect as string) ?? Routes.DASHBOARD)
    }
  })
}

export default useAuthedRedirect
